import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, FormField, Input } from '@vd/ui';
import { AuthLayout } from './AuthLayout';
import { api } from '../../lib/api';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!token) {
    return (
      <AuthLayout title="Link invalid" footer={<Link to="/forgot">Request a new link</Link>}>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
          This reset link is missing a token or has expired.
        </p>
      </AuthLayout>
    );
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (password.length < 10) { setErr('Password must be at least 10 characters.'); return; }
    if (password !== confirm) { setErr('Passwords don’t match.'); return; }
    setSubmitting(true);
    try {
      await api.resetPassword(token, password);
      navigate('/signin', { replace: true });
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Set a new password" footer={<Link to="/signin">Back to sign in</Link>}>
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <FormField label="New password" help="At least 10 characters.">
          <Input type="password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} />
        </FormField>
        <FormField label="Confirm password">
          <Input type="password" required minLength={10} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </FormField>
        {err && <div style={{ color: 'var(--danger)', fontSize: 12 }}>{err}</div>}
        <Button variant="primary" size="lg" loading={submitting} type="submit">
          Reset password
        </Button>
      </form>
    </AuthLayout>
  );
}
